// src/utils/productTemplates.js
import { db } from '../firebase/config';
import { collection, getDocs, addDoc, updateDoc, deleteDoc, doc, getDoc } from 'firebase/firestore';

// Collection name for custom products
const CUSTOM_PRODUCTS_COLLECTION = 'kajjaCustomProducts';

// ============================================
// COMPLETE TASK LIBRARY
// ============================================
export const taskLibrary = [
  { id: 'client-consultation', category: 'Planning', name: 'Client Consultation', defaultDays: 1, required: true, order: 1 },
  { id: 'site-visit', category: 'Planning', name: 'Site Visit & Measurements', defaultDays: 1, required: true, order: 2 },
  { id: 'design-approval', category: 'Design', name: 'Client Approval of Design', defaultDays: 2, required: true, order: 3 },
  { id: 'production-drawing', category: 'Design', name: 'Production Drawings', defaultDays: 2, required: true, order: 4 },
  { id: 'quotation', category: 'Sales', name: 'Make Quotation', defaultDays: 1, required: true, order: 5 },
  { id: 'sales-order', category: 'Sales', name: 'Share Sales Order', defaultDays: 1, required: true, order: 6 },
  { id: 'cutting-list', category: 'Production Prep', name: 'Cutting List', defaultDays: 1, required: true, order: 7 },
  { id: 'material-procurement', category: 'Procurement', name: 'Materials Procurement', defaultDays: 3, required: true, order: 8 },
  { id: 'sample-approval', category: 'Quality', name: 'Sample Material Approval', defaultDays: 1, required: true, order: 9 },
  { id: 'machine-work', category: 'Production', name: 'Machine Work', defaultDays: 3, required: true, order: 10 },
  { id: 'edge-banding', category: 'Production', name: 'Edge Banding', defaultDays: 1, required: false, order: 11 },
  { id: 'assembly', category: 'Production', name: 'Assembly', defaultDays: 3, required: true, order: 12 },
  { id: 'finishing', category: 'Production', name: 'Finishing', defaultDays: 2, required: true, order: 13 },
  { id: 'quality-checks', category: 'Quality', name: 'Quality Checks', defaultDays: 1, required: true, order: 14 },
  { id: 'delivery', category: 'Logistics', name: 'Delivery to Site', defaultDays: 1, required: true, order: 15 },
  { id: 'installation', category: 'Installation', name: 'Installation', defaultDays: 2, required: true, order: 16 },
  { id: 'handover', category: 'Completion', name: 'Client Handover', defaultDays: 1, required: true, order: 17 }
];

// ============================================
// 1. TABLES CATEGORY
// ============================================
const tablesProducts = [
  {
    id: 'dining-table-4seater',
    name: 'Dining Table (4-Seater)',
    category: 'tables',
    defaultTasks: [
      { name: 'Client Consultation', defaultDays: 1, required: true, order: 1 },
      { name: 'Site Visit & Measurements', defaultDays: 1, required: true, order: 2 },
      { name: 'Design Approval', defaultDays: 1, required: true, order: 3 },
      { name: 'Production Drawings', defaultDays: 1, required: true, order: 4 },
      { name: 'Make Quotation', defaultDays: 1, required: true, order: 5 },
      { name: 'Share Sales Order', defaultDays: 1, required: true, order: 6 },
      { name: 'Cutting List', defaultDays: 1, required: true, order: 7 },
      { name: 'Materials Procurement', defaultDays: 2, required: true, order: 8 },
      { name: 'Machine Work', defaultDays: 2, required: true, order: 9 },
      { name: 'Assembly', defaultDays: 1, required: true, order: 10 },
      { name: 'Finishing', defaultDays: 2, required: true, order: 11 },
      { name: 'Quality Checks', defaultDays: 1, required: true, order: 12 },
      { name: 'Delivery & Installation', defaultDays: 1, required: true, order: 13 },
      { name: 'Client Handover', defaultDays: 1, required: true, order: 14 }
    ]
  },
  {
    id: 'dining-table-6seater',
    name: 'Dining Table (6-Seater)',
    category: 'tables',
    defaultTasks: [
      { name: 'Client Consultation', defaultDays: 1, required: true, order: 1 },
      { name: 'Site Visit & Measurements', defaultDays: 1, required: true, order: 2 },
      { name: 'Design Approval', defaultDays: 2, required: true, order: 3 },
      { name: 'Production Drawings', defaultDays: 2, required: true, order: 4 },
      { name: 'Make Quotation', defaultDays: 1, required: true, order: 5 },
      { name: 'Share Sales Order', defaultDays: 1, required: true, order: 6 },
      { name: 'Cutting List', defaultDays: 1, required: true, order: 7 },
      { name: 'Materials Procurement', defaultDays: 3, required: true, order: 8 },
      { name: 'Machine Work', defaultDays: 2, required: true, order: 9 },
      { name: 'Assembly', defaultDays: 2, required: true, order: 10 },
      { name: 'Finishing', defaultDays: 2, required: true, order: 11 },
      { name: 'Quality Checks', defaultDays: 1, required: true, order: 12 },
      { name: 'Delivery & Installation', defaultDays: 1, required: true, order: 13 },
      { name: 'Client Handover', defaultDays: 1, required: true, order: 14 }
    ]
  },
  {
    id: 'dining-table-8seater',
    name: 'Dining Table (8-Seater)',
    category: 'tables',
    defaultTasks: [
      { name: 'Client Consultation', defaultDays: 1, required: true, order: 1 },
      { name: 'Site Visit & Measurements', defaultDays: 1, required: true, order: 2 },
      { name: 'Design Approval', defaultDays: 2, required: true, order: 3 },
      { name: 'Production Drawings', defaultDays: 2, required: true, order: 4 },
      { name: 'Make Quotation', defaultDays: 1, required: true, order: 5 },
      { name: 'Share Sales Order', defaultDays: 1, required: true, order: 6 },
      { name: 'Cutting List', defaultDays: 2, required: true, order: 7 },
      { name: 'Materials Procurement', defaultDays: 3, required: true, order: 8 },
      { name: 'Machine Work', defaultDays: 3, required: true, order: 9 },
      { name: 'Assembly', defaultDays: 2, required: true, order: 10 },
      { name: 'Finishing', defaultDays: 2, required: true, order: 11 },
      { name: 'Quality Checks', defaultDays: 1, required: true, order: 12 },
      { name: 'Delivery & Installation', defaultDays: 1, required: true, order: 13 },
      { name: 'Client Handover', defaultDays: 1, required: true, order: 14 }
    ]
  },
  {
    id: 'coffee-table',
    name: 'Coffee Table',
    category: 'tables',
    defaultTasks: [
      { name: 'Client Consultation', defaultDays: 1, required: true, order: 1 },
      { name: 'Site Visit & Measurements', defaultDays: 1, required: true, order: 2 },
      { name: 'Design Approval', defaultDays: 1, required: true, order: 3 },
      { name: 'Production Drawings', defaultDays: 1, required: true, order: 4 },
      { name: 'Make Quotation', defaultDays: 1, required: true, order: 5 },
      { name: 'Share Sales Order', defaultDays: 1, required: true, order: 6 },
      { name: 'Cutting List', defaultDays: 1, required: true, order: 7 },
      { name: 'Materials Procurement', defaultDays: 2, required: true, order: 8 },
      { name: 'Machine Work', defaultDays: 1, required: true, order: 9 },
      { name: 'Assembly', defaultDays: 1, required: true, order: 10 },
      { name: 'Finishing', defaultDays: 1, required: true, order: 11 },
      { name: 'Quality Checks', defaultDays: 1, required: true, order: 12 },
      { name: 'Delivery & Installation', defaultDays: 1, required: true, order: 13 },
      { name: 'Client Handover', defaultDays: 1, required: true, order: 14 }
    ]
  },
  {
    id: 'side-table',
    name: 'Side Table / End Table',
    category: 'tables',
    defaultTasks: [
      { name: 'Client Consultation', defaultDays: 1, required: true, order: 1 },
      { name: 'Site Visit & Measurements', defaultDays: 1, required: true, order: 2 },
      { name: 'Design Approval', defaultDays: 1, required: true, order: 3 },
      { name: 'Production Drawings', defaultDays: 1, required: true, order: 4 },
      { name: 'Make Quotation', defaultDays: 1, required: true, order: 5 },
      { name: 'Share Sales Order', defaultDays: 1, required: true, order: 6 },
      { name: 'Cutting List', defaultDays: 1, required: true, order: 7 },
      { name: 'Materials Procurement', defaultDays: 2, required: true, order: 8 },
      { name: 'Machine Work', defaultDays: 1, required: true, order: 9 },
      { name: 'Assembly', defaultDays: 1, required: true, order: 10 },
      { name: 'Finishing', defaultDays: 1, required: true, order: 11 },
      { name: 'Quality Checks', defaultDays: 1, required: true, order: 12 },
      { name: 'Delivery & Installation', defaultDays: 1, required: true, order: 13 },
      { name: 'Client Handover', defaultDays: 1, required: true, order: 14 }
    ]
  },
  {
    id: 'console-table',
    name: 'Console Table',
    category: 'tables',
    defaultTasks: [
      { name: 'Client Consultation', defaultDays: 1, required: true, order: 1 },
      { name: 'Site Visit & Measurements', defaultDays: 1, required: true, order: 2 },
      { name: 'Design Approval', defaultDays: 1, required: true, order: 3 },
      { name: 'Production Drawings', defaultDays: 1, required: true, order: 4 },
      { name: 'Make Quotation', defaultDays: 1, required: true, order: 5 },
      { name: 'Share Sales Order', defaultDays: 1, required: true, order: 6 },
      { name: 'Cutting List', defaultDays: 1, required: true, order: 7 },
      { name: 'Materials Procurement', defaultDays: 2, required: true, order: 8 },
      { name: 'Machine Work', defaultDays: 1, required: true, order: 9 },
      { name: 'Assembly', defaultDays: 1, required: true, order: 10 },
      { name: 'Finishing', defaultDays: 1, required: true, order: 11 },
      { name: 'Quality Checks', defaultDays: 1, required: true, order: 12 },
      { name: 'Delivery & Installation', defaultDays: 1, required: true, order: 13 },
      { name: 'Client Handover', defaultDays: 1, required: true, order: 14 }
    ]
  },
  {
    id: 'conference-table',
    name: 'Conference Table',
    category: 'tables',
    defaultTasks: [
      { name: 'Client Consultation', defaultDays: 1, required: true, order: 1 },
      { name: 'Site Visit & Measurements', defaultDays: 1, required: true, order: 2 },
      { name: 'Design Approval', defaultDays: 2, required: true, order: 3 },
      { name: 'Production Drawings', defaultDays: 2, required: true, order: 4 },
      { name: 'Make Quotation', defaultDays: 1, required: true, order: 5 },
      { name: 'Share Sales Order', defaultDays: 1, required: true, order: 6 },
      { name: 'Cutting List', defaultDays: 2, required: true, order: 7 },
      { name: 'Materials Procurement', defaultDays: 4, required: true, order: 8 },
      { name: 'Machine Work', defaultDays: 3, required: true, order: 9 },
      { name: 'Assembly', defaultDays: 2, required: true, order: 10 },
      { name: 'Finishing', defaultDays: 2, required: true, order: 11 },
      { name: 'Quality Checks', defaultDays: 1, required: true, order: 12 },
      { name: 'Delivery & Installation', defaultDays: 1, required: true, order: 13 },
      { name: 'Client Handover', defaultDays: 1, required: true, order: 14 }
    ]
  },
  {
    id: 'restaurant-table',
    name: 'Restaurant Table',
    category: 'tables',
    defaultTasks: [
      { name: 'Client Consultation', defaultDays: 1, required: true, order: 1 },
      { name: 'Site Visit & Measurements', defaultDays: 1, required: true, order: 2 },
      { name: 'Design Approval', defaultDays: 2, required: true, order: 3 },
      { name: 'Production Drawings', defaultDays: 2, required: true, order: 4 },
      { name: 'Make Quotation', defaultDays: 1, required: true, order: 5 },
      { name: 'Share Sales Order', defaultDays: 1, required: true, order: 6 },
      { name: 'Cutting List', defaultDays: 2, required: true, order: 7 },
      { name: 'Materials Procurement', defaultDays: 3, required: true, order: 8 },
      { name: 'Machine Work', defaultDays: 3, required: true, order: 9 },
      { name: 'Assembly', defaultDays: 2, required: true, order: 10 },
      { name: 'Finishing (Commercial Grade)', defaultDays: 2, required: true, order: 11 },
      { name: 'Quality Checks', defaultDays: 1, required: true, order: 12 },
      { name: 'Delivery & Installation', defaultDays: 1, required: true, order: 13 },
      { name: 'Client Handover', defaultDays: 1, required: true, order: 14 }
    ]
  }
];

// ============================================
// 2. CHAIRS CATEGORY
// ============================================
const chairsProducts = [
  {
    id: 'dining-chair',
    name: 'Dining Chair',
    category: 'chairs',
    defaultTasks: [
      { name: 'Client Consultation', defaultDays: 1, required: true, order: 1 },
      { name: 'Site Visit & Measurements', defaultDays: 1, required: true, order: 2 },
      { name: 'Design Approval', defaultDays: 1, required: true, order: 3 },
      { name: 'Production Drawings', defaultDays: 1, required: true, order: 4 },
      { name: 'Make Quotation', defaultDays: 1, required: true, order: 5 },
      { name: 'Share Sales Order', defaultDays: 1, required: true, order: 6 },
      { name: 'Cutting List', defaultDays: 1, required: true, order: 7 },
      { name: 'Materials Procurement', defaultDays: 2, required: true, order: 8 },
      { name: 'Machine Work', defaultDays: 1, required: true, order: 9 },
      { name: 'Assembly', defaultDays: 1, required: true, order: 10 },
      { name: 'Upholstery', defaultDays: 1, required: false, order: 11 },
      { name: 'Finishing', defaultDays: 1, required: true, order: 12 },
      { name: 'Quality Checks', defaultDays: 1, required: true, order: 13 },
      { name: 'Delivery & Installation', defaultDays: 1, required: true, order: 14 },
      { name: 'Client Handover', defaultDays: 1, required: true, order: 15 }
    ]
  },
  {
    id: 'armchair',
    name: 'Armchair',
    category: 'chairs',
    defaultTasks: [
      { name: 'Client Consultation', defaultDays: 1, required: true, order: 1 },
      { name: 'Site Visit & Measurements', defaultDays: 1, required: true, order: 2 },
      { name: 'Design Approval', defaultDays: 2, required: true, order: 3 },
      { name: 'Production Drawings', defaultDays: 2, required: true, order: 4 },
      { name: 'Make Quotation', defaultDays: 1, required: true, order: 5 },
      { name: 'Share Sales Order', defaultDays: 1, required: true, order: 6 },
      { name: 'Cutting List', defaultDays: 1, required: true, order: 7 },
      { name: 'Materials Procurement', defaultDays: 3, required: true, order: 8 },
      { name: 'Machine Work', defaultDays: 2, required: true, order: 9 },
      { name: 'Assembly', defaultDays: 2, required: true, order: 10 },
      { name: 'Upholstery', defaultDays: 2, required: true, order: 11 },
      { name: 'Finishing', defaultDays: 1, required: true, order: 12 },
      { name: 'Quality Checks', defaultDays: 1, required: true, order: 13 },
      { name: 'Delivery & Installation', defaultDays: 1, required: true, order: 14 },
      { name: 'Client Handover', defaultDays: 1, required: true, order: 15 }
    ]
  },
  {
    id: 'office-chair',
    name: 'Office Chair',
    category: 'chairs',
    defaultTasks: [
      { name: 'Client Consultation', defaultDays: 1, required: true, order: 1 },
      { name: 'Site Visit & Measurements', defaultDays: 1, required: true, order: 2 },
      { name: 'Design Approval', defaultDays: 2, required: true, order: 3 },
      { name: 'Production Drawings', defaultDays: 2, required: true, order: 4 },
      { name: 'Make Quotation', defaultDays: 1, required: true, order: 5 },
      { name: 'Share Sales Order', defaultDays: 1, required: true, order: 6 },
      { name: 'Cutting List', defaultDays: 1, required: true, order: 7 },
      { name: 'Materials Procurement', defaultDays: 3, required: true, order: 8 },
      { name: 'Machine Work', defaultDays: 2, required: true, order: 9 },
      { name: 'Assembly', defaultDays: 2, required: true, order: 10 },
      { name: 'Upholstery', defaultDays: 2, required: true, order: 11 },
      { name: 'Finishing', defaultDays: 1, required: true, order: 12 },
      { name: 'Quality Checks', defaultDays: 1, required: true, order: 13 },
      { name: 'Delivery & Installation', defaultDays: 1, required: true, order: 14 },
      { name: 'Client Handover', defaultDays: 1, required: true, order: 15 }
    ]
  },
  {
    id: 'rocking-chair',
    name: 'Rocking Chair',
    category: 'chairs',
    defaultTasks: [
      { name: 'Client Consultation', defaultDays: 1, required: true, order: 1 },
      { name: 'Site Visit & Measurements', defaultDays: 1, required: true, order: 2 },
      { name: 'Design Approval', defaultDays: 2, required: true, order: 3 },
      { name: 'Production Drawings', defaultDays: 2, required: true, order: 4 },
      { name: 'Make Quotation', defaultDays: 1, required: true, order: 5 },
      { name: 'Share Sales Order', defaultDays: 1, required: true, order: 6 },
      { name: 'Cutting List', defaultDays: 1, required: true, order: 7 },
      { name: 'Materials Procurement', defaultDays: 3, required: true, order: 8 },
      { name: 'Machine Work', defaultDays: 2, required: true, order: 9 },
      { name: 'Assembly (with rockers)', defaultDays: 2, required: true, order: 10 },
      { name: 'Finishing', defaultDays: 2, required: true, order: 11 },
      { name: 'Quality Checks', defaultDays: 1, required: true, order: 12 },
      { name: 'Delivery & Installation', defaultDays: 1, required: true, order: 13 },
      { name: 'Client Handover', defaultDays: 1, required: true, order: 14 }
    ]
  },
  {
    id: 'bar-stool',
    name: 'Bar Stool',
    category: 'chairs',
    defaultTasks: [
      { name: 'Client Consultation', defaultDays: 1, required: true, order: 1 },
      { name: 'Site Visit & Measurements', defaultDays: 1, required: true, order: 2 },
      { name: 'Design Approval', defaultDays: 1, required: true, order: 3 },
      { name: 'Production Drawings', defaultDays: 1, required: true, order: 4 },
      { name: 'Make Quotation', defaultDays: 1, required: true, order: 5 },
      { name: 'Share Sales Order', defaultDays: 1, required: true, order: 6 },
      { name: 'Cutting List', defaultDays: 1, required: true, order: 7 },
      { name: 'Materials Procurement', defaultDays: 2, required: true, order: 8 },
      { name: 'Machine Work', defaultDays: 1, required: true, order: 9 },
      { name: 'Assembly', defaultDays: 1, required: true, order: 10 },
      { name: 'Finishing', defaultDays: 1, required: true, order: 11 },
      { name: 'Quality Checks', defaultDays: 1, required: true, order: 12 },
      { name: 'Delivery & Installation', defaultDays: 1, required: true, order: 13 },
      { name: 'Client Handover', defaultDays: 1, required: true, order: 14 }
    ]
  },
  {
    id: 'lounge-chair',
    name: 'Lounge Chair',
    category: 'chairs',
    defaultTasks: [
      { name: 'Client Consultation', defaultDays: 1, required: true, order: 1 },
      { name: 'Site Visit & Measurements', defaultDays: 1, required: true, order: 2 },
      { name: 'Design Approval', defaultDays: 2, required: true, order: 3 },
      { name: 'Production Drawings', defaultDays: 2, required: true, order: 4 },
      { name: 'Make Quotation', defaultDays: 1, required: true, order: 5 },
      { name: 'Share Sales Order', defaultDays: 1, required: true, order: 6 },
      { name: 'Cutting List', defaultDays: 1, required: true, order: 7 },
      { name: 'Materials Procurement', defaultDays: 3, required: true, order: 8 },
      { name: 'Machine Work', defaultDays: 2, required: true, order: 9 },
      { name: 'Assembly', defaultDays: 2, required: true, order: 10 },
      { name: 'Upholstery', defaultDays: 2, required: true, order: 11 },
      { name: 'Finishing', defaultDays: 1, required: true, order: 12 },
      { name: 'Quality Checks', defaultDays: 1, required: true, order: 13 },
      { name: 'Delivery & Installation', defaultDays: 1, required: true, order: 14 },
      { name: 'Client Handover', defaultDays: 1, required: true, order: 15 }
    ]
  }
];

// ============================================
// 3. WARDROBES CATEGORY
// ============================================
const wardrobesProducts = [
  {
    id: 'wardrobe-2door',
    name: '2-Door Wardrobe',
    category: 'wardrobes',
    defaultTasks: [
      { name: 'Client Consultation', defaultDays: 1, required: true, order: 1 },
      { name: 'Site Visit & Measurements', defaultDays: 1, required: true, order: 2 },
      { name: 'Design Approval', defaultDays: 2, required: true, order: 3 },
      { name: 'Production Drawings', defaultDays: 2, required: true, order: 4 },
      { name: 'Make Quotation', defaultDays: 1, required: true, order: 5 },
      { name: 'Share Sales Order', defaultDays: 1, required: true, order: 6 },
      { name: 'Cutting List', defaultDays: 1, required: true, order: 7 },
      { name: 'Materials Procurement', defaultDays: 3, required: true, order: 8 },
      { name: 'Machine Work', defaultDays: 2, required: true, order: 9 },
      { name: 'Edge Banding', defaultDays: 1, required: false, order: 10 },
      { name: 'Assembly', defaultDays: 2, required: true, order: 11 },
      { name: 'Install Doors & Hardware', defaultDays: 1, required: true, order: 12 },
      { name: 'Finishing', defaultDays: 2, required: true, order: 13 },
      { name: 'Quality Checks', defaultDays: 1, required: true, order: 14 },
      { name: 'Delivery & Installation', defaultDays: 1, required: true, order: 15 },
      { name: 'Client Handover', defaultDays: 1, required: true, order: 16 }
    ]
  },
  {
    id: 'wardrobe-3door',
    name: '3-Door Wardrobe',
    category: 'wardrobes',
    defaultTasks: [
      { name: 'Client Consultation', defaultDays: 1, required: true, order: 1 },
      { name: 'Site Visit & Measurements', defaultDays: 1, required: true, order: 2 },
      { name: 'Design Approval', defaultDays: 2, required: true, order: 3 },
      { name: 'Production Drawings', defaultDays: 2, required: true, order: 4 },
      { name: 'Make Quotation', defaultDays: 1, required: true, order: 5 },
      { name: 'Share Sales Order', defaultDays: 1, required: true, order: 6 },
      { name: 'Cutting List', defaultDays: 2, required: true, order: 7 },
      { name: 'Materials Procurement', defaultDays: 3, required: true, order: 8 },
      { name: 'Machine Work', defaultDays: 3, required: true, order: 9 },
      { name: 'Edge Banding', defaultDays: 1, required: false, order: 10 },
      { name: 'Assembly', defaultDays: 3, required: true, order: 11 },
      { name: 'Install Doors & Hardware', defaultDays: 1, required: true, order: 12 },
      { name: 'Finishing', defaultDays: 2, required: true, order: 13 },
      { name: 'Quality Checks', defaultDays: 1, required: true, order: 14 },
      { name: 'Delivery & Installation', defaultDays: 1, required: true, order: 15 },
      { name: 'Client Handover', defaultDays: 1, required: true, order: 16 }
    ]
  },
  {
    id: 'wardrobe-4door',
    name: '4-Door Wardrobe',
    category: 'wardrobes',
    defaultTasks: [
      { name: 'Client Consultation', defaultDays: 1, required: true, order: 1 },
      { name: 'Site Visit & Measurements', defaultDays: 1, required: true, order: 2 },
      { name: 'Design Approval', defaultDays: 2, required: true, order: 3 },
      { name: 'Production Drawings', defaultDays: 2, required: true, order: 4 },
      { name: 'Make Quotation', defaultDays: 1, required: true, order: 5 },
      { name: 'Share Sales Order', defaultDays: 1, required: true, order: 6 },
      { name: 'Cutting List', defaultDays: 2, required: true, order: 7 },
      { name: 'Materials Procurement', defaultDays: 4, required: true, order: 8 },
      { name: 'Machine Work', defaultDays: 3, required: true, order: 9 },
      { name: 'Edge Banding', defaultDays: 1, required: false, order: 10 },
      { name: 'Assembly', defaultDays: 3, required: true, order: 11 },
      { name: 'Install Doors & Hardware', defaultDays: 1, required: true, order: 12 },
      { name: 'Finishing', defaultDays: 2, required: true, order: 13 },
      { name: 'Quality Checks', defaultDays: 1, required: true, order: 14 },
      { name: 'Delivery & Installation', defaultDays: 1, required: true, order: 15 },
      { name: 'Client Handover', defaultDays: 1, required: true, order: 16 }
    ]
  },
  {
    id: 'walkin-wardrobe',
    name: 'Walk-in Wardrobe',
    category: 'wardrobes',
    defaultTasks: [
      { name: 'Client Consultation', defaultDays: 1, required: true, order: 1 },
      { name: 'Site Visit & Measurements', defaultDays: 1, required: true, order: 2 },
      { name: 'Design Approval', defaultDays: 3, required: true, order: 3 },
      { name: 'Production Drawings', defaultDays: 3, required: true, order: 4 },
      { name: 'Make Quotation', defaultDays: 1, required: true, order: 5 },
      { name: 'Share Sales Order', defaultDays: 1, required: true, order: 6 },
      { name: 'Cutting List', defaultDays: 3, required: true, order: 7 },
      { name: 'Materials Procurement', defaultDays: 5, required: true, order: 8 },
      { name: 'Machine Work', defaultDays: 4, required: true, order: 9 },
      { name: 'Edge Banding', defaultDays: 2, required: true, order: 10 },
      { name: 'Assembly', defaultDays: 4, required: true, order: 11 },
      { name: 'Install Doors & Hardware', defaultDays: 2, required: true, order: 12 },
      { name: 'Finishing', defaultDays: 3, required: true, order: 13 },
      { name: 'Quality Checks', defaultDays: 1, required: true, order: 14 },
      { name: 'Delivery & Installation', defaultDays: 2, required: true, order: 15 },
      { name: 'Client Handover', defaultDays: 1, required: true, order: 16 }
    ]
  }
];

// ============================================
// 4. SHOE RACKS CATEGORY
// ============================================
const shoeRacksProducts = [
  {
    id: 'shoe-rack-small',
    name: 'Small Shoe Rack (10 pairs)',
    category: 'shoe-racks',
    defaultTasks: [
      { name: 'Client Consultation', defaultDays: 1, required: true, order: 1 },
      { name: 'Site Visit & Measurements', defaultDays: 1, required: true, order: 2 },
      { name: 'Design Approval', defaultDays: 1, required: true, order: 3 },
      { name: 'Production Drawings', defaultDays: 1, required: true, order: 4 },
      { name: 'Make Quotation', defaultDays: 1, required: true, order: 5 },
      { name: 'Share Sales Order', defaultDays: 1, required: true, order: 6 },
      { name: 'Cutting List', defaultDays: 1, required: true, order: 7 },
      { name: 'Materials Procurement', defaultDays: 2, required: true, order: 8 },
      { name: 'Machine Work', defaultDays: 1, required: true, order: 9 },
      { name: 'Assembly', defaultDays: 1, required: true, order: 10 },
      { name: 'Finishing', defaultDays: 1, required: true, order: 11 },
      { name: 'Quality Checks', defaultDays: 1, required: true, order: 12 },
      { name: 'Delivery & Installation', defaultDays: 1, required: true, order: 13 },
      { name: 'Client Handover', defaultDays: 1, required: true, order: 14 }
    ]
  },
  {
    id: 'shoe-rack-medium',
    name: 'Medium Shoe Rack (20 pairs)',
    category: 'shoe-racks',
    defaultTasks: [
      { name: 'Client Consultation', defaultDays: 1, required: true, order: 1 },
      { name: 'Site Visit & Measurements', defaultDays: 1, required: true, order: 2 },
      { name: 'Design Approval', defaultDays: 1, required: true, order: 3 },
      { name: 'Production Drawings', defaultDays: 1, required: true, order: 4 },
      { name: 'Make Quotation', defaultDays: 1, required: true, order: 5 },
      { name: 'Share Sales Order', defaultDays: 1, required: true, order: 6 },
      { name: 'Cutting List', defaultDays: 1, required: true, order: 7 },
      { name: 'Materials Procurement', defaultDays: 2, required: true, order: 8 },
      { name: 'Machine Work', defaultDays: 1, required: true, order: 9 },
      { name: 'Assembly', defaultDays: 1, required: true, order: 10 },
      { name: 'Finishing', defaultDays: 1, required: true, order: 11 },
      { name: 'Quality Checks', defaultDays: 1, required: true, order: 12 },
      { name: 'Delivery & Installation', defaultDays: 1, required: true, order: 13 },
      { name: 'Client Handover', defaultDays: 1, required: true, order: 14 }
    ]
  },
  {
    id: 'shoe-rack-large',
    name: 'Large Shoe Rack (30 pairs)',
    category: 'shoe-racks',
    defaultTasks: [
      { name: 'Client Consultation', defaultDays: 1, required: true, order: 1 },
      { name: 'Site Visit & Measurements', defaultDays: 1, required: true, order: 2 },
      { name: 'Design Approval', defaultDays: 1, required: true, order: 3 },
      { name: 'Production Drawings', defaultDays: 1, required: true, order: 4 },
      { name: 'Make Quotation', defaultDays: 1, required: true, order: 5 },
      { name: 'Share Sales Order', defaultDays: 1, required: true, order: 6 },
      { name: 'Cutting List', defaultDays: 1, required: true, order: 7 },
      { name: 'Materials Procurement', defaultDays: 3, required: true, order: 8 },
      { name: 'Machine Work', defaultDays: 2, required: true, order: 9 },
      { name: 'Assembly', defaultDays: 2, required: true, order: 10 },
      { name: 'Finishing', defaultDays: 1, required: true, order: 11 },
      { name: 'Quality Checks', defaultDays: 1, required: true, order: 12 },
      { name: 'Delivery & Installation', defaultDays: 1, required: true, order: 13 },
      { name: 'Client Handover', defaultDays: 1, required: true, order: 14 }
    ]
  },
  {
    id: 'shoe-cabinet',
    name: 'Shoe Cabinet (with doors)',
    category: 'shoe-racks',
    defaultTasks: [
      { name: 'Client Consultation', defaultDays: 1, required: true, order: 1 },
      { name: 'Site Visit & Measurements', defaultDays: 1, required: true, order: 2 },
      { name: 'Design Approval', defaultDays: 1, required: true, order: 3 },
      { name: 'Production Drawings', defaultDays: 1, required: true, order: 4 },
      { name: 'Make Quotation', defaultDays: 1, required: true, order: 5 },
      { name: 'Share Sales Order', defaultDays: 1, required: true, order: 6 },
      { name: 'Cutting List', defaultDays: 1, required: true, order: 7 },
      { name: 'Materials Procurement', defaultDays: 2, required: true, order: 8 },
      { name: 'Machine Work', defaultDays: 2, required: true, order: 9 },
      { name: 'Edge Banding', defaultDays: 1, required: false, order: 10 },
      { name: 'Assembly', defaultDays: 2, required: true, order: 11 },
      { name: 'Install Doors', defaultDays: 1, required: true, order: 12 },
      { name: 'Finishing', defaultDays: 1, required: true, order: 13 },
      { name: 'Quality Checks', defaultDays: 1, required: true, order: 14 },
      { name: 'Delivery & Installation', defaultDays: 1, required: true, order: 15 },
      { name: 'Client Handover', defaultDays: 1, required: true, order: 16 }
    ]
  }
];

// ============================================
// 5. COUNTERS CATEGORY
// ============================================
const countersProducts = [
  {
    id: 'kitchen-counter',
    name: 'Kitchen Counter',
    category: 'counters',
    defaultTasks: [
      { name: 'Client Consultation', defaultDays: 1, required: true, order: 1 },
      { name: 'Site Visit & Measurements', defaultDays: 1, required: true, order: 2 },
      { name: 'Design Approval', defaultDays: 2, required: true, order: 3 },
      { name: 'Production Drawings', defaultDays: 2, required: true, order: 4 },
      { name: 'Make Quotation', defaultDays: 1, required: true, order: 5 },
      { name: 'Share Sales Order', defaultDays: 1, required: true, order: 6 },
      { name: 'Cutting List', defaultDays: 2, required: true, order: 7 },
      { name: 'Materials Procurement', defaultDays: 3, required: true, order: 8 },
      { name: 'Machine Work', defaultDays: 3, required: true, order: 9 },
      { name: 'Edge Banding', defaultDays: 2, required: true, order: 10 },
      { name: 'Assembly', defaultDays: 3, required: true, order: 11 },
      { name: 'Finishing', defaultDays: 2, required: true, order: 12 },
      { name: 'Quality Checks', defaultDays: 1, required: true, order: 13 },
      { name: 'Delivery & Installation', defaultDays: 1, required: true, order: 14 },
      { name: 'Client Handover', defaultDays: 1, required: true, order: 15 }
    ]
  },
  {
    id: 'reception-counter',
    name: 'Reception Counter',
    category: 'counters',
    defaultTasks: [
      { name: 'Client Consultation', defaultDays: 1, required: true, order: 1 },
      { name: 'Site Visit & Measurements', defaultDays: 1, required: true, order: 2 },
      { name: 'Design Approval', defaultDays: 2, required: true, order: 3 },
      { name: 'Production Drawings', defaultDays: 2, required: true, order: 4 },
      { name: 'Make Quotation', defaultDays: 1, required: true, order: 5 },
      { name: 'Share Sales Order', defaultDays: 1, required: true, order: 6 },
      { name: 'Cutting List', defaultDays: 2, required: true, order: 7 },
      { name: 'Materials Procurement', defaultDays: 4, required: true, order: 8 },
      { name: 'Machine Work', defaultDays: 3, required: true, order: 9 },
      { name: 'Edge Banding', defaultDays: 2, required: true, order: 10 },
      { name: 'Assembly', defaultDays: 3, required: true, order: 11 },
      { name: 'Finishing', defaultDays: 2, required: true, order: 12 },
      { name: 'Quality Checks', defaultDays: 1, required: true, order: 13 },
      { name: 'Delivery & Installation', defaultDays: 2, required: true, order: 14 },
      { name: 'Client Handover', defaultDays: 1, required: true, order: 15 }
    ]
  },
  {
    id: 'bar-counter',
    name: 'Bar Counter',
    category: 'counters',
    defaultTasks: [
      { name: 'Client Consultation', defaultDays: 1, required: true, order: 1 },
      { name: 'Site Visit & Measurements', defaultDays: 1, required: true, order: 2 },
      { name: 'Design Approval', defaultDays: 2, required: true, order: 3 },
      { name: 'Production Drawings', defaultDays: 2, required: true, order: 4 },
      { name: 'Make Quotation', defaultDays: 1, required: true, order: 5 },
      { name: 'Share Sales Order', defaultDays: 1, required: true, order: 6 },
      { name: 'Cutting List', defaultDays: 2, required: true, order: 7 },
      { name: 'Materials Procurement', defaultDays: 3, required: true, order: 8 },
      { name: 'Machine Work', defaultDays: 3, required: true, order: 9 },
      { name: 'Edge Banding', defaultDays: 2, required: true, order: 10 },
      { name: 'Assembly', defaultDays: 3, required: true, order: 11 },
      { name: 'Finishing', defaultDays: 2, required: true, order: 12 },
      { name: 'Quality Checks', defaultDays: 1, required: true, order: 13 },
      { name: 'Delivery & Installation', defaultDays: 1, required: true, order: 14 },
      { name: 'Client Handover', defaultDays: 1, required: true, order: 15 }
    ]
  },
  {
    id: 'checkout-counter',
    name: 'Checkout Counter (Retail)',
    category: 'counters',
    defaultTasks: [
      { name: 'Client Consultation', defaultDays: 1, required: true, order: 1 },
      { name: 'Site Visit & Measurements', defaultDays: 1, required: true, order: 2 },
      { name: 'Design Approval', defaultDays: 2, required: true, order: 3 },
      { name: 'Production Drawings', defaultDays: 2, required: true, order: 4 },
      { name: 'Make Quotation', defaultDays: 1, required: true, order: 5 },
      { name: 'Share Sales Order', defaultDays: 1, required: true, order: 6 },
      { name: 'Cutting List', defaultDays: 2, required: true, order: 7 },
      { name: 'Materials Procurement', defaultDays: 3, required: true, order: 8 },
      { name: 'Machine Work', defaultDays: 3, required: true, order: 9 },
      { name: 'Edge Banding', defaultDays: 2, required: true, order: 10 },
      { name: 'Assembly', defaultDays: 3, required: true, order: 11 },
      { name: 'Finishing', defaultDays: 2, required: true, order: 12 },
      { name: 'Quality Checks', defaultDays: 1, required: true, order: 13 },
      { name: 'Delivery & Installation', defaultDays: 1, required: true, order: 14 },
      { name: 'Client Handover', defaultDays: 1, required: true, order: 15 }
    ]
  }
];

// ============================================
// 6. BEDS CATEGORY
// ============================================
const bedsProducts = [
  {
    id: 'single-bed',
    name: 'Single Bed',
    category: 'beds',
    defaultTasks: [
      { name: 'Client Consultation', defaultDays: 1, required: true, order: 1 },
      { name: 'Site Visit & Measurements', defaultDays: 1, required: true, order: 2 },
      { name: 'Design Approval', defaultDays: 1, required: true, order: 3 },
      { name: 'Production Drawings', defaultDays: 1, required: true, order: 4 },
      { name: 'Make Quotation', defaultDays: 1, required: true, order: 5 },
      { name: 'Share Sales Order', defaultDays: 1, required: true, order: 6 },
      { name: 'Cutting List', defaultDays: 1, required: true, order: 7 },
      { name: 'Materials Procurement', defaultDays: 2, required: true, order: 8 },
      { name: 'Machine Work', defaultDays: 2, required: true, order: 9 },
      { name: 'Assembly', defaultDays: 1, required: true, order: 10 },
      { name: 'Finishing', defaultDays: 1, required: true, order: 11 },
      { name: 'Quality Checks', defaultDays: 1, required: true, order: 12 },
      { name: 'Delivery & Installation', defaultDays: 1, required: true, order: 13 },
      { name: 'Client Handover', defaultDays: 1, required: true, order: 14 }
    ]
  },
  {
    id: 'double-bed',
    name: 'Double Bed',
    category: 'beds',
    defaultTasks: [
      { name: 'Client Consultation', defaultDays: 1, required: true, order: 1 },
      { name: 'Site Visit & Measurements', defaultDays: 1, required: true, order: 2 },
      { name: 'Design Approval', defaultDays: 1, required: true, order: 3 },
      { name: 'Production Drawings', defaultDays: 1, required: true, order: 4 },
      { name: 'Make Quotation', defaultDays: 1, required: true, order: 5 },
      { name: 'Share Sales Order', defaultDays: 1, required: true, order: 6 },
      { name: 'Cutting List', defaultDays: 1, required: true, order: 7 },
      { name: 'Materials Procurement', defaultDays: 2, required: true, order: 8 },
      { name: 'Machine Work', defaultDays: 2, required: true, order: 9 },
      { name: 'Assembly', defaultDays: 1, required: true, order: 10 },
      { name: 'Finishing', defaultDays: 1, required: true, order: 11 },
      { name: 'Quality Checks', defaultDays: 1, required: true, order: 12 },
      { name: 'Delivery & Installation', defaultDays: 1, required: true, order: 13 },
      { name: 'Client Handover', defaultDays: 1, required: true, order: 14 }
    ]
  },
  {
    id: 'queen-bed',
    name: 'Queen Bed',
    category: 'beds',
    defaultTasks: [
      { name: 'Client Consultation', defaultDays: 1, required: true, order: 1 },
      { name: 'Site Visit & Measurements', defaultDays: 1, required: true, order: 2 },
      { name: 'Design Approval', defaultDays: 2, required: true, order: 3 },
      { name: 'Production Drawings', defaultDays: 2, required: true, order: 4 },
      { name: 'Make Quotation', defaultDays: 1, required: true, order: 5 },
      { name: 'Share Sales Order', defaultDays: 1, required: true, order: 6 },
      { name: 'Cutting List', defaultDays: 1, required: true, order: 7 },
      { name: 'Materials Procurement', defaultDays: 3, required: true, order: 8 },
      { name: 'Machine Work', defaultDays: 2, required: true, order: 9 },
      { name: 'Assembly', defaultDays: 2, required: true, order: 10 },
      { name: 'Finishing', defaultDays: 2, required: true, order: 11 },
      { name: 'Quality Checks', defaultDays: 1, required: true, order: 12 },
      { name: 'Delivery & Installation', defaultDays: 1, required: true, order: 13 },
      { name: 'Client Handover', defaultDays: 1, required: true, order: 14 }
    ]
  },
  {
    id: 'king-bed',
    name: 'King Bed',
    category: 'beds',
    defaultTasks: [
      { name: 'Client Consultation', defaultDays: 1, required: true, order: 1 },
      { name: 'Site Visit & Measurements', defaultDays: 1, required: true, order: 2 },
      { name: 'Design Approval', defaultDays: 2, required: true, order: 3 },
      { name: 'Production Drawings', defaultDays: 2, required: true, order: 4 },
      { name: 'Make Quotation', defaultDays: 1, required: true, order: 5 },
      { name: 'Share Sales Order', defaultDays: 1, required: true, order: 6 },
      { name: 'Cutting List', defaultDays: 2, required: true, order: 7 },
      { name: 'Materials Procurement', defaultDays: 3, required: true, order: 8 },
      { name: 'Machine Work', defaultDays: 3, required: true, order: 9 },
      { name: 'Assembly', defaultDays: 2, required: true, order: 10 },
      { name: 'Finishing', defaultDays: 2, required: true, order: 11 },
      { name: 'Quality Checks', defaultDays: 1, required: true, order: 12 },
      { name: 'Delivery & Installation', defaultDays: 1, required: true, order: 13 },
      { name: 'Client Handover', defaultDays: 1, required: true, order: 14 }
    ]
  },
  {
    id: 'bunk-bed',
    name: 'Bunk Bed',
    category: 'beds',
    defaultTasks: [
      { name: 'Client Consultation', defaultDays: 1, required: true, order: 1 },
      { name: 'Site Visit & Measurements', defaultDays: 1, required: true, order: 2 },
      { name: 'Design Approval', defaultDays: 2, required: true, order: 3 },
      { name: 'Production Drawings', defaultDays: 2, required: true, order: 4 },
      { name: 'Make Quotation', defaultDays: 1, required: true, order: 5 },
      { name: 'Share Sales Order', defaultDays: 1, required: true, order: 6 },
      { name: 'Cutting List', defaultDays: 2, required: true, order: 7 },
      { name: 'Materials Procurement', defaultDays: 3, required: true, order: 8 },
      { name: 'Machine Work', defaultDays: 3, required: true, order: 9 },
      { name: 'Assembly (with ladder)', defaultDays: 2, required: true, order: 10 },
      { name: 'Finishing', defaultDays: 2, required: true, order: 11 },
      { name: 'Quality Checks', defaultDays: 1, required: true, order: 12 },
      { name: 'Delivery & Installation', defaultDays: 1, required: true, order: 13 },
      { name: 'Client Handover', defaultDays: 1, required: true, order: 14 }
    ]
  },
  {
    id: 'ottoman-bed',
    name: 'Ottoman Bed (Storage)',
    category: 'beds',
    defaultTasks: [
      { name: 'Client Consultation', defaultDays: 1, required: true, order: 1 },
      { name: 'Site Visit & Measurements', defaultDays: 1, required: true, order: 2 },
      { name: 'Design Approval', defaultDays: 2, required: true, order: 3 },
      { name: 'Production Drawings', defaultDays: 2, required: true, order: 4 },
      { name: 'Make Quotation', defaultDays: 1, required: true, order: 5 },
      { name: 'Share Sales Order', defaultDays: 1, required: true, order: 6 },
      { name: 'Cutting List', defaultDays: 2, required: true, order: 7 },
      { name: 'Materials Procurement', defaultDays: 3, required: true, order: 8 },
      { name: 'Machine Work', defaultDays: 3, required: true, order: 9 },
      { name: 'Assembly (with gas lift)', defaultDays: 2, required: true, order: 10 },
      { name: 'Finishing', defaultDays: 2, required: true, order: 11 },
      { name: 'Quality Checks', defaultDays: 1, required: true, order: 12 },
      { name: 'Delivery & Installation', defaultDays: 1, required: true, order: 13 },
      { name: 'Client Handover', defaultDays: 1, required: true, order: 14 }
    ]
  }
];

// ============================================
// 7. SOFAS CATEGORY
// ============================================
const sofasProducts = [
  {
    id: '2seater-sofa',
    name: '2-Seater Sofa',
    category: 'sofas',
    defaultTasks: [
      { name: 'Client Consultation', defaultDays: 1, required: true, order: 1 },
      { name: 'Site Visit & Measurements', defaultDays: 1, required: true, order: 2 },
      { name: 'Design Approval', defaultDays: 2, required: true, order: 3 },
      { name: 'Production Drawings', defaultDays: 2, required: true, order: 4 },
      { name: 'Make Quotation', defaultDays: 1, required: true, order: 5 },
      { name: 'Share Sales Order', defaultDays: 1, required: true, order: 6 },
      { name: 'Cutting List', defaultDays: 1, required: true, order: 7 },
      { name: 'Materials Procurement', defaultDays: 3, required: true, order: 8 },
      { name: 'Machine Work', defaultDays: 2, required: true, order: 9 },
      { name: 'Frame Assembly', defaultDays: 2, required: true, order: 10 },
      { name: 'Upholstery', defaultDays: 2, required: true, order: 11 },
      { name: 'Finishing', defaultDays: 1, required: true, order: 12 },
      { name: 'Quality Checks', defaultDays: 1, required: true, order: 13 },
      { name: 'Delivery & Installation', defaultDays: 1, required: true, order: 14 },
      { name: 'Client Handover', defaultDays: 1, required: true, order: 15 }
    ]
  },
  {
    id: '3seater-sofa',
    name: '3-Seater Sofa',
    category: 'sofas',
    defaultTasks: [
      { name: 'Client Consultation', defaultDays: 1, required: true, order: 1 },
      { name: 'Site Visit & Measurements', defaultDays: 1, required: true, order: 2 },
      { name: 'Design Approval', defaultDays: 2, required: true, order: 3 },
      { name: 'Production Drawings', defaultDays: 2, required: true, order: 4 },
      { name: 'Make Quotation', defaultDays: 1, required: true, order: 5 },
      { name: 'Share Sales Order', defaultDays: 1, required: true, order: 6 },
      { name: 'Cutting List', defaultDays: 1, required: true, order: 7 },
      { name: 'Materials Procurement', defaultDays: 3, required: true, order: 8 },
      { name: 'Machine Work', defaultDays: 3, required: true, order: 9 },
      { name: 'Frame Assembly', defaultDays: 2, required: true, order: 10 },
      { name: 'Upholstery', defaultDays: 3, required: true, order: 11 },
      { name: 'Finishing', defaultDays: 2, required: true, order: 12 },
      { name: 'Quality Checks', defaultDays: 1, required: true, order: 13 },
      { name: 'Delivery & Installation', defaultDays: 1, required: true, order: 14 },
      { name: 'Client Handover', defaultDays: 1, required: true, order: 15 }
    ]
  },
  {
    id: 'sectional-sofa',
    name: 'Sectional Sofa (L-Shape)',
    category: 'sofas',
    defaultTasks: [
      { name: 'Client Consultation', defaultDays: 1, required: true, order: 1 },
      { name: 'Site Visit & Measurements', defaultDays: 1, required: true, order: 2 },
      { name: 'Design Approval', defaultDays: 2, required: true, order: 3 },
      { name: 'Production Drawings', defaultDays: 2, required: true, order: 4 },
      { name: 'Make Quotation', defaultDays: 1, required: true, order: 5 },
      { name: 'Share Sales Order', defaultDays: 1, required: true, order: 6 },
      { name: 'Cutting List', defaultDays: 2, required: true, order: 7 },
      { name: 'Materials Procurement', defaultDays: 4, required: true, order: 8 },
      { name: 'Machine Work', defaultDays: 3, required: true, order: 9 },
      { name: 'Frame Assembly', defaultDays: 3, required: true, order: 10 },
      { name: 'Upholstery', defaultDays: 3, required: true, order: 11 },
      { name: 'Finishing', defaultDays: 2, required: true, order: 12 },
      { name: 'Quality Checks', defaultDays: 1, required: true, order: 13 },
      { name: 'Delivery & Installation', defaultDays: 2, required: true, order: 14 },
      { name: 'Client Handover', defaultDays: 1, required: true, order: 15 }
    ]
  },
  {
    id: 'sleeper-sofa',
    name: 'Sleeper Sofa (Sofa Bed)',
    category: 'sofas',
    defaultTasks: [
      { name: 'Client Consultation', defaultDays: 1, required: true, order: 1 },
      { name: 'Site Visit & Measurements', defaultDays: 1, required: true, order: 2 },
      { name: 'Design Approval', defaultDays: 2, required: true, order: 3 },
      { name: 'Production Drawings', defaultDays: 2, required: true, order: 4 },
      { name: 'Make Quotation', defaultDays: 1, required: true, order: 5 },
      { name: 'Share Sales Order', defaultDays: 1, required: true, order: 6 },
      { name: 'Cutting List', defaultDays: 2, required: true, order: 7 },
      { name: 'Materials Procurement', defaultDays: 4, required: true, order: 8 },
      { name: 'Machine Work', defaultDays: 3, required: true, order: 9 },
      { name: 'Frame Assembly (with mechanism)', defaultDays: 3, required: true, order: 10 },
      { name: 'Upholstery', defaultDays: 3, required: true, order: 11 },
      { name: 'Finishing', defaultDays: 2, required: true, order: 12 },
      { name: 'Quality Checks', defaultDays: 1, required: true, order: 13 },
      { name: 'Delivery & Installation', defaultDays: 1, required: true, order: 14 },
      { name: 'Client Handover', defaultDays: 1, required: true, order: 15 }
    ]
  }
];

// ============================================
// 8. CABINETS CATEGORY
// ============================================
const cabinetsProducts = [
  {
    id: 'wall-cabinet',
    name: 'Wall Cabinet',
    category: 'cabinets',
    defaultTasks: [
      { name: 'Client Consultation', defaultDays: 1, required: true, order: 1 },
      { name: 'Site Visit & Measurements', defaultDays: 1, required: true, order: 2 },
      { name: 'Design Approval', defaultDays: 1, required: true, order: 3 },
      { name: 'Production Drawings', defaultDays: 1, required: true, order: 4 },
      { name: 'Make Quotation', defaultDays: 1, required: true, order: 5 },
      { name: 'Share Sales Order', defaultDays: 1, required: true, order: 6 },
      { name: 'Cutting List', defaultDays: 1, required: true, order: 7 },
      { name: 'Materials Procurement', defaultDays: 2, required: true, order: 8 },
      { name: 'Machine Work', defaultDays: 1, required: true, order: 9 },
      { name: 'Edge Banding', defaultDays: 1, required: false, order: 10 },
      { name: 'Assembly', defaultDays: 1, required: true, order: 11 },
      { name: 'Finishing', defaultDays: 1, required: true, order: 12 },
      { name: 'Quality Checks', defaultDays: 1, required: true, order: 13 },
      { name: 'Delivery & Installation', defaultDays: 1, required: true, order: 14 },
      { name: 'Client Handover', defaultDays: 1, required: true, order: 15 }
    ]
  },
  {
    id: 'base-cabinet',
    name: 'Base Cabinet',
    category: 'cabinets',
    defaultTasks: [
      { name: 'Client Consultation', defaultDays: 1, required: true, order: 1 },
      { name: 'Site Visit & Measurements', defaultDays: 1, required: true, order: 2 },
      { name: 'Design Approval', defaultDays: 1, required: true, order: 3 },
      { name: 'Production Drawings', defaultDays: 1, required: true, order: 4 },
      { name: 'Make Quotation', defaultDays: 1, required: true, order: 5 },
      { name: 'Share Sales Order', defaultDays: 1, required: true, order: 6 },
      { name: 'Cutting List', defaultDays: 1, required: true, order: 7 },
      { name: 'Materials Procurement', defaultDays: 2, required: true, order: 8 },
      { name: 'Machine Work', defaultDays: 2, required: true, order: 9 },
      { name: 'Edge Banding', defaultDays: 1, required: false, order: 10 },
      { name: 'Assembly', defaultDays: 2, required: true, order: 11 },
      { name: 'Finishing', defaultDays: 1, required: true, order: 12 },
      { name: 'Quality Checks', defaultDays: 1, required: true, order: 13 },
      { name: 'Delivery & Installation', defaultDays: 1, required: true, order: 14 },
      { name: 'Client Handover', defaultDays: 1, required: true, order: 15 }
    ]
  },
  {
    id: 'display-cabinet',
    name: 'Display Cabinet (Glass)',
    category: 'cabinets',
    defaultTasks: [
      { name: 'Client Consultation', defaultDays: 1, required: true, order: 1 },
      { name: 'Site Visit & Measurements', defaultDays: 1, required: true, order: 2 },
      { name: 'Design Approval', defaultDays: 2, required: true, order: 3 },
      { name: 'Production Drawings', defaultDays: 2, required: true, order: 4 },
      { name: 'Make Quotation', defaultDays: 1, required: true, order: 5 },
      { name: 'Share Sales Order', defaultDays: 1, required: true, order: 6 },
      { name: 'Cutting List', defaultDays: 1, required: true, order: 7 },
      { name: 'Materials Procurement', defaultDays: 3, required: true, order: 8 },
      { name: 'Machine Work', defaultDays: 2, required: true, order: 9 },
      { name: 'Edge Banding', defaultDays: 1, required: false, order: 10 },
      { name: 'Assembly', defaultDays: 2, required: true, order: 11 },
      { name: 'Glass Installation', defaultDays: 1, required: true, order: 12 },
      { name: 'Finishing', defaultDays: 2, required: true, order: 13 },
      { name: 'Quality Checks', defaultDays: 1, required: true, order: 14 },
      { name: 'Delivery & Installation', defaultDays: 1, required: true, order: 15 },
      { name: 'Client Handover', defaultDays: 1, required: true, order: 16 }
    ]
  },
  {
    id: 'medicine-cabinet',
    name: 'Medicine Cabinet',
    category: 'cabinets',
    defaultTasks: [
      { name: 'Client Consultation', defaultDays: 1, required: true, order: 1 },
      { name: 'Site Visit & Measurements', defaultDays: 1, required: true, order: 2 },
      { name: 'Design Approval', defaultDays: 1, required: true, order: 3 },
      { name: 'Production Drawings', defaultDays: 1, required: true, order: 4 },
      { name: 'Make Quotation', defaultDays: 1, required: true, order: 5 },
      { name: 'Share Sales Order', defaultDays: 1, required: true, order: 6 },
      { name: 'Cutting List', defaultDays: 1, required: true, order: 7 },
      { name: 'Materials Procurement', defaultDays: 2, required: true, order: 8 },
      { name: 'Machine Work', defaultDays: 1, required: true, order: 9 },
      { name: 'Assembly', defaultDays: 1, required: true, order: 10 },
      { name: 'Mirror Installation', defaultDays: 1, required: true, order: 11 },
      { name: 'Finishing', defaultDays: 1, required: true, order: 12 },
      { name: 'Quality Checks', defaultDays: 1, required: true, order: 13 },
      { name: 'Delivery & Installation', defaultDays: 1, required: true, order: 14 },
      { name: 'Client Handover', defaultDays: 1, required: true, order: 15 }
    ]
  }
];

// ============================================
// 9. DESKS CATEGORY
// ============================================
const desksProducts = [
  {
    id: 'office-desk',
    name: 'Office Desk',
    category: 'desks',
    defaultTasks: [
      { name: 'Client Consultation', defaultDays: 1, required: true, order: 1 },
      { name: 'Site Visit & Measurements', defaultDays: 1, required: true, order: 2 },
      { name: 'Design Approval', defaultDays: 1, required: true, order: 3 },
      { name: 'Production Drawings', defaultDays: 1, required: true, order: 4 },
      { name: 'Make Quotation', defaultDays: 1, required: true, order: 5 },
      { name: 'Share Sales Order', defaultDays: 1, required: true, order: 6 },
      { name: 'Cutting List', defaultDays: 1, required: true, order: 7 },
      { name: 'Materials Procurement', defaultDays: 2, required: true, order: 8 },
      { name: 'Machine Work', defaultDays: 2, required: true, order: 9 },
      { name: 'Assembly', defaultDays: 1, required: true, order: 10 },
      { name: 'Finishing', defaultDays: 1, required: true, order: 11 },
      { name: 'Quality Checks', defaultDays: 1, required: true, order: 12 },
      { name: 'Delivery & Installation', defaultDays: 1, required: true, order: 13 },
      { name: 'Client Handover', defaultDays: 1, required: true, order: 14 }
    ]
  },
  {
    id: 'computer-desk',
    name: 'Computer Desk',
    category: 'desks',
    defaultTasks: [
      { name: 'Client Consultation', defaultDays: 1, required: true, order: 1 },
      { name: 'Site Visit & Measurements', defaultDays: 1, required: true, order: 2 },
      { name: 'Design Approval', defaultDays: 1, required: true, order: 3 },
      { name: 'Production Drawings', defaultDays: 1, required: true, order: 4 },
      { name: 'Make Quotation', defaultDays: 1, required: true, order: 5 },
      { name: 'Share Sales Order', defaultDays: 1, required: true, order: 6 },
      { name: 'Cutting List', defaultDays: 1, required: true, order: 7 },
      { name: 'Materials Procurement', defaultDays: 2, required: true, order: 8 },
      { name: 'Machine Work', defaultDays: 2, required: true, order: 9 },
      { name: 'Assembly', defaultDays: 1, required: true, order: 10 },
      { name: 'Finishing', defaultDays: 1, required: true, order: 11 },
      { name: 'Quality Checks', defaultDays: 1, required: true, order: 12 },
      { name: 'Delivery & Installation', defaultDays: 1, required: true, order: 13 },
      { name: 'Client Handover', defaultDays: 1, required: true, order: 14 }
    ]
  },
  {
    id: 'standing-desk',
    name: 'Standing Desk',
    category: 'desks',
    defaultTasks: [
      { name: 'Client Consultation', defaultDays: 1, required: true, order: 1 },
      { name: 'Site Visit & Measurements', defaultDays: 1, required: true, order: 2 },
      { name: 'Design Approval', defaultDays: 2, required: true, order: 3 },
      { name: 'Production Drawings', defaultDays: 2, required: true, order: 4 },
      { name: 'Make Quotation', defaultDays: 1, required: true, order: 5 },
      { name: 'Share Sales Order', defaultDays: 1, required: true, order: 6 },
      { name: 'Cutting List', defaultDays: 1, required: true, order: 7 },
      { name: 'Materials Procurement', defaultDays: 3, required: true, order: 8 },
      { name: 'Machine Work', defaultDays: 2, required: true, order: 9 },
      { name: 'Assembly (with mechanism)', defaultDays: 2, required: true, order: 10 },
      { name: 'Finishing', defaultDays: 2, required: true, order: 11 },
      { name: 'Quality Checks', defaultDays: 1, required: true, order: 12 },
      { name: 'Delivery & Installation', defaultDays: 1, required: true, order: 13 },
      { name: 'Client Handover', defaultDays: 1, required: true, order: 14 }
    ]
  }
];

// ============================================
// 10. SHELVES CATEGORY
// ============================================
const shelvesProducts = [
  {
    id: 'wall-shelf',
    name: 'Wall Shelf',
    category: 'shelves',
    defaultTasks: [
      { name: 'Client Consultation', defaultDays: 1, required: true, order: 1 },
      { name: 'Site Visit & Measurements', defaultDays: 1, required: true, order: 2 },
      { name: 'Design Approval', defaultDays: 1, required: true, order: 3 },
      { name: 'Production Drawings', defaultDays: 1, required: true, order: 4 },
      { name: 'Make Quotation', defaultDays: 1, required: true, order: 5 },
      { name: 'Share Sales Order', defaultDays: 1, required: true, order: 6 },
      { name: 'Cutting List', defaultDays: 1, required: true, order: 7 },
      { name: 'Materials Procurement', defaultDays: 1, required: true, order: 8 },
      { name: 'Machine Work', defaultDays: 1, required: true, order: 9 },
      { name: 'Assembly', defaultDays: 1, required: true, order: 10 },
      { name: 'Finishing', defaultDays: 1, required: true, order: 11 },
      { name: 'Quality Checks', defaultDays: 1, required: true, order: 12 },
      { name: 'Delivery & Installation', defaultDays: 1, required: true, order: 13 },
      { name: 'Client Handover', defaultDays: 1, required: true, order: 14 }
    ]
  },
  {
    id: 'floating-shelf',
    name: 'Floating Shelf',
    category: 'shelves',
    defaultTasks: [
      { name: 'Client Consultation', defaultDays: 1, required: true, order: 1 },
      { name: 'Site Visit & Measurements', defaultDays: 1, required: true, order: 2 },
      { name: 'Design Approval', defaultDays: 1, required: true, order: 3 },
      { name: 'Production Drawings', defaultDays: 1, required: true, order: 4 },
      { name: 'Make Quotation', defaultDays: 1, required: true, order: 5 },
      { name: 'Share Sales Order', defaultDays: 1, required: true, order: 6 },
      { name: 'Cutting List', defaultDays: 1, required: true, order: 7 },
      { name: 'Materials Procurement', defaultDays: 1, required: true, order: 8 },
      { name: 'Machine Work', defaultDays: 1, required: true, order: 9 },
      { name: 'Assembly', defaultDays: 1, required: true, order: 10 },
      { name: 'Finishing', defaultDays: 1, required: true, order: 11 },
      { name: 'Quality Checks', defaultDays: 1, required: true, order: 12 },
      { name: 'Delivery & Installation', defaultDays: 1, required: true, order: 13 },
      { name: 'Client Handover', defaultDays: 1, required: true, order: 14 }
    ]
  },
  {
    id: 'corner-shelf',
    name: 'Corner Shelf',
    category: 'shelves',
    defaultTasks: [
      { name: 'Client Consultation', defaultDays: 1, required: true, order: 1 },
      { name: 'Site Visit & Measurements', defaultDays: 1, required: true, order: 2 },
      { name: 'Design Approval', defaultDays: 1, required: true, order: 3 },
      { name: 'Production Drawings', defaultDays: 1, required: true, order: 4 },
      { name: 'Make Quotation', defaultDays: 1, required: true, order: 5 },
      { name: 'Share Sales Order', defaultDays: 1, required: true, order: 6 },
      { name: 'Cutting List', defaultDays: 1, required: true, order: 7 },
      { name: 'Materials Procurement', defaultDays: 1, required: true, order: 8 },
      { name: 'Machine Work', defaultDays: 1, required: true, order: 9 },
      { name: 'Assembly', defaultDays: 1, required: true, order: 10 },
      { name: 'Finishing', defaultDays: 1, required: true, order: 11 },
      { name: 'Quality Checks', defaultDays: 1, required: true, order: 12 },
      { name: 'Delivery & Installation', defaultDays: 1, required: true, order: 13 },
      { name: 'Client Handover', defaultDays: 1, required: true, order: 14 }
    ]
  },
  {
    id: 'book-shelf',
    name: 'Book Shelf',
    category: 'shelves',
    defaultTasks: [
      { name: 'Client Consultation', defaultDays: 1, required: true, order: 1 },
      { name: 'Site Visit & Measurements', defaultDays: 1, required: true, order: 2 },
      { name: 'Design Approval', defaultDays: 1, required: true, order: 3 },
      { name: 'Production Drawings', defaultDays: 1, required: true, order: 4 },
      { name: 'Make Quotation', defaultDays: 1, required: true, order: 5 },
      { name: 'Share Sales Order', defaultDays: 1, required: true, order: 6 },
      { name: 'Cutting List', defaultDays: 1, required: true, order: 7 },
      { name: 'Materials Procurement', defaultDays: 2, required: true, order: 8 },
      { name: 'Machine Work', defaultDays: 2, required: true, order: 9 },
      { name: 'Assembly', defaultDays: 2, required: true, order: 10 },
      { name: 'Finishing', defaultDays: 1, required: true, order: 11 },
      { name: 'Quality Checks', defaultDays: 1, required: true, order: 12 },
      { name: 'Delivery & Installation', defaultDays: 1, required: true, order: 13 },
      { name: 'Client Handover', defaultDays: 1, required: true, order: 14 }
    ]
  }
];

// ============================================
// EXPORT ALL PRODUCT CATEGORIES
// ============================================
export const productCategories = {
  'tables': {
    id: 'tables',
    name: '📐 Tables',
    icon: '📐',
    products: tablesProducts
  },
  'chairs': {
    id: 'chairs',
    name: '🪑 Chairs',
    icon: '🪑',
    products: chairsProducts
  },
  'wardrobes': {
    id: 'wardrobes',
    name: '👔 Wardrobes',
    icon: '👔',
    products: wardrobesProducts
  },
  'shoe-racks': {
    id: 'shoe-racks',
    name: '👞 Shoe Racks',
    icon: '👞',
    products: shoeRacksProducts
  },
  'counters': {
    id: 'counters',
    name: '📊 Counters',
    icon: '📊',
    products: countersProducts
  },
  'beds': {
    id: 'beds',
    name: '🛏️ Beds',
    icon: '🛏️',
    products: bedsProducts
  },
  'sofas': {
    id: 'sofas',
    name: '🛋️ Sofas',
    icon: '🛋️',
    products: sofasProducts
  },
  'cabinets': {
    id: 'cabinets',
    name: '📦 Cabinets',
    icon: '📦',
    products: cabinetsProducts
  },
  'desks': {
    id: 'desks',
    name: '💻 Desks',
    icon: '💻',
    products: desksProducts
  },
  'shelves': {
    id: 'shelves',
    name: '📚 Shelves',
    icon: '📚',
    products: shelvesProducts
  }
};

// ============================================
// FIRESTORE FUNCTIONS FOR CUSTOM PRODUCTS
// ============================================

// Load custom products from Firestore
export const loadCustomProducts = async () => {
  try {
    const querySnapshot = await getDocs(collection(db, CUSTOM_PRODUCTS_COLLECTION));
    const products = querySnapshot.docs.map(doc => ({ 
      id: doc.id, 
      ...doc.data() 
    }));
    console.log('✅ Loaded custom products:', products.length);
    return products;
  } catch (error) {
    console.error('Error loading custom products:', error);
    return [];
  }
};

// Save custom product to Firestore
export const saveCustomProduct = async (product) => {
  try {
    const docRef = await addDoc(collection(db, CUSTOM_PRODUCTS_COLLECTION), {
      name: product.name,
      category: product.category,
      description: product.description || '',
      defaultTasks: product.defaultTasks,
      createdAt: new Date().toISOString()
    });
    console.log('✅ Created custom product with ID:', docRef.id);
    return { id: docRef.id, ...product };
  } catch (error) {
    console.error('Error saving custom product:', error);
    throw error;
  }
};

// Delete custom product from Firestore
export const deleteCustomProduct = async (productId) => {
  try {
    await deleteDoc(doc(db, CUSTOM_PRODUCTS_COLLECTION, productId));
    console.log('✅ Deleted custom product:', productId);
    return true;
  } catch (error) {
    console.error('Error deleting custom product:', error);
    throw error;
  }
};

// Get all products (predefined + custom from Firestore)
export const getAllProducts = async () => {
  const allProducts = [];
  
  // Add predefined products
  Object.values(productCategories).forEach(category => {
    category.products.forEach(product => {
      allProducts.push({
        ...product,
        categoryId: category.id,
        categoryName: category.name,
        categoryIcon: category.icon,
        isCustom: false
      });
    });
  });
  
  // Add custom products from Firestore
  const customProducts = await loadCustomProducts();
  customProducts.forEach(product => {
    allProducts.push({
      id: product.id,
      name: product.name,
      category: product.category,
      defaultTasks: product.defaultTasks,
      categoryId: 'custom',
      categoryName: '✨ Custom Products',
      categoryIcon: '✨',
      isCustom: true
    });
  });
  
  return allProducts;
};

// Get product by ID
export const getProductById = async (productId) => {
  for (const category of Object.values(productCategories)) {
    const product = category.products.find(p => p.id === productId);
    if (product) {
      return {
        ...product,
        categoryId: category.id,
        categoryName: category.name,
        categoryIcon: category.icon,
        isCustom: false
      };
    }
  }
  
  try {
    const docRef = doc(db, CUSTOM_PRODUCTS_COLLECTION, productId);
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
      return {
        id: docSnap.id,
        ...docSnap.data(),
        categoryId: 'custom',
        categoryName: '✨ Custom Products',
        categoryIcon: '✨',
        isCustom: true
      };
    }
  } catch (error) {
    console.error('Error getting product by ID:', error);
  }
  
  return null;
};

// Create new custom product in Firestore
export const createCustomProduct = async (productName, category, tasks) => {
  const newProduct = {
    name: productName,
    category: category,
    description: '',
    createdAt: new Date().toISOString(),
    defaultTasks: tasks.map((task, index) => ({
      name: task.name,
      defaultDays: task.days,
      required: task.required !== false,
      order: index + 1,
      description: task.description || ''
    }))
  };
  
  const docRef = await addDoc(collection(db, CUSTOM_PRODUCTS_COLLECTION), newProduct);
  console.log('✅ Created new product with ID:', docRef.id);
  
  return { 
    id: docRef.id, 
    ...newProduct 
  };
};